<label class="image-upload-container btn btn-bwm">
    <span>Select Image</span>
    <input #imageInput
           type="file"
           accept="image/*"
           (change)="processFile(imageInput)">
</label>